<template>
  <Layout>
    <div class="container" style="margin-top:94px; max-width:720px;">
      <h1 style="text-align:center;">{{$store.state.webcast.copy.title}}</h1>
      <h3 style="text-align:center;">{{ $t("select_stream_below") }}</h3>
    </div>
    <div class="container" style="margin-top:30px; max-width:320px;">
      <Row v-for="stream in streams" :key="stream._id">
        <Button
          long
          size="large"
          class="stream-select-btn"
          @click="streamRoute(stream._id)"
          type="default"
        >{{stream.name}}</Button>
      </Row>
    </div>
  </Layout>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import Navbar from "@/components/Navbar.vue";

export default {
  components: {
    Navbar
  },
  computed: {
    ...mapGetters("stream", { streamsInStore: "find" }),
    streams() {
      return this.streamsInStore({ query: {} }).data;
    }
  },
  methods: {
    ...mapActions("stream", {
      findStreams: "find"
    }),
    streamRoute(streamId) {
      this.$router.push({ name: "live", query: { streamId: streamId } });
    }
  },
  created() {}
};
</script>

<style>
.stream-select-btn {
  text-transform: capitalize !important;
  margin-bottom: 16px !important;
}
</style>
